<div class="custom_modal">
  <div class="modal-header">
    <div class="title">
      {{ title }}
    </div>
    <div>
      <span class="close_button" (click)="close(false)">
        <i class="fa fa-times"></i>
      </span>
    </div>
  </div>
  <div class="modal-body row">
    <div class="half" [ngClass]="{ 'col-6': data.day.isFuture && !data.readonly, 'col-12': !data.day.isFuture || data.readonly }">
      <div class="subtitle">
        <span class="bold" *ngIf="!data.readonly">{{ 'ORDERS.LIST.SUBTITLE' | translate }}</span>
      </div>
      <div class="orders_list">
        <div class="order row" *ngFor="let order of orders" (click)="close(false, order.etmOrderNumber, order.salesOrderNumber)">
          <div class="col-2">
            <app-status layout="BULLET" key="{{ 'ORDER_' + order.status.id }}" height="40" [size]="1"> </app-status>
          </div>
          <div class="col-10 row">
            <div class="col-4 column">
              <span class="head">{{ 'ORDERS.LIST.LABELS.NUMBER' | translate }}</span>
              <span>{{ order.etmOrderNumber }}</span>
            </div>
            <div class="col-4 column">
              <span class="head">{{ 'ORDERS.LIST.LABELS.FROM' | translate }}</span>
              <span>{{ order.from.name }}</span>
            </div>
            <div class="col-4 column">
              <span class="head">{{ 'ORDERS.LIST.LABELS.TO' | translate }}</span>
              <span>{{ order.to.name }}</span>
            </div>
          </div>
        </div>
        <div *ngIf="orders.length === 0 && !isLoading">
          {{ 'CALENDAR.ADD_ORDER_MODAL.NO_ORDERS' | translate }}
        </div>
        <div *ngIf="isLoading">
          {{ 'ADMIN.I18N.BUTTONS.LOADING' | translate }}
        </div>
      </div>
    </div>
    <div class="col-6 half" *ngIf="data.day.isFuture && !data.readonly">
      <div class="subtitle">
        {{ 'CALENDAR.ADD_ORDER_MODAL.START_FROM_A' | translate }}
        <span class="bold">{{ 'CALENDAR.ADD_ORDER_MODAL.NEW_ORDER' | translate }}</span>
      </div>

      <a mat-button class="default" (click)="close(true)"> <i class="fa fa-plus-square-o" aria-hidden="true"></i> {{ 'CALENDAR.ADD_ORDER_MODAL.NEW_ORDER' | translate }} </a>

      <div class="hr" *ngIf="data.templates.length > 0"></div>

      <div class="subtitle" *ngIf="data.templates.length > 0">
        {{ 'CALENDAR.ADD_ORDER_MODAL.START_FROM_A' | translate }}
        <span class="bold">{{ 'CALENDAR.ADD_ORDER_MODAL.TEMPLATE' | translate }}</span>
      </div>

      <div class="template_list" *ngIf="data.templates.length > 0">
        <div *ngFor="let template of data.templates" class="template" (click)="close(true, template.id)">
          <span class="bold">{{ template.name }}</span>
        </div>
      </div>
    </div>
    <europool-loadingbar [loading]="isLoading"></europool-loadingbar>
  </div>
  <div class="modal-footer">
    <a class="btn-cancel" (click)="close(false)">{{ 'SHARED.BUTTONS.CANCEL' | translate }}</a>
  </div>
</div>
